<template>
  <div class="h-100 main-container">
    <nav
      class="startpage-navbar navbar sticky-top navbar-light justify-content-between d-block d-sm-flex">
      <div class="container-fluid m-3">
        <a v-if="isLoggedIn" href="/diagnostik">
          <img :src="levumiSmall" alt="Levumi - Startseite" width="48" height="48" />
          Levumi
        </a>
        <b-nav-item v-else class="navbar-brand d-block d-xs-inline" to="/">
          <img :src="levumiSmall" alt="Levumi - Startseite" width="48" height="48" />
          Levumi
          <b-alert v-if="!!systemMessage" class="ms-auto mb-0 d-inline" show variant="danger">
            {{ systemMessage }}
          </b-alert>
        </b-nav-item>
        <a v-if="!isMaintenance" href="/testen" class="btn btn-outline-secondary">
          Zugang für Schülerinnen und Schüler
        </a>
        <div class="mt-2 mt-md-0">
          <div v-if="isLoggedIn">
            <a class="btn btn-outline-secondary" href="/diagnostik">{{ user }}</a>
          </div>
          <div v-else>
            <b-dropdown
              id="login"
              auto-close="false"
              menu-class="login-dropdown"
              variant="outline-secondary"
              :text="isMaintenance ? 'Admin-Zugang' : 'Einloggen'"
              right>
              <div class="px-4 py-3 mx-3">
                <login-form />
              </div>
            </b-dropdown>
          </div>
        </div>
      </div>
    </nav>
    <wiki-display />
    <MaintenanceMode v-if="isMaintenance" />
    <div v-else class="main-container startpage-container">
      <router-view :is-logged-in="isLoggedIn" />
    </div>
    <footer-bar />
  </div>
</template>

<script>
  import { RouterView } from 'vue-router'
  import { useWikiStore } from 'src/store/wikiStore'
  import FooterBar from '../shared/footer-bar.vue'
  import levumiSmallSrc from '../../../assets/images/shared/Levumi-normal_small.png'
  import LoginForm from './components/login-form.vue'
  import MaintenanceMode from './components/maintenance-mode.vue'
  import WikiDisplay from '../wiki/wiki-display.vue'

  export default {
    name: 'StartpageApp',
    components: { FooterBar, RouterView, LoginForm, MaintenanceMode, WikiDisplay },
    provide() {
      return {
        passwordMismatch: this.passwordMismatch,
      }
    },
    setup() {
      const wikiStore = useWikiStore()
      return { wikiStore }
    },
    watch: {
      '$route.query': {
        immediate: true,
        async handler() {
          if (this.$route.query?.wiki) {
            await this.wikiStore.fetch()
            const isArticlePresent = this.wikiStore.checkArticle(this.$route.query.wiki)
            if (isArticlePresent) {
              this.wikiStore.showArticle(this.$route.query.wiki)
            }
          }
        },
      },
    },
    props: {
      user: String,
      retry: String,
      initialTimeStamp: String,
      isMaintenance: Boolean,
      mode: String,
    },
    data() {
      return { showLogin: false }
    },
    computed: {
      isLoggedIn() {
        return this.user !== 'none'
      },
      passwordMismatch() {
        return this.retry === 'true'
      },
      systemMessage() {
        switch (this.mode) {
          case 'staging':
            return 'TEST-SYSTEM'
          case 'development':
            return 'DEV'
          default:
            return ''
        }
      },
      levumiSmall() {
        return levumiSmallSrc
      },
    },
    mounted() {
      sessionStorage.setItem('ts', this.initialTimeStamp)
    },
  }
</script>
